import { Skeleton, useMediaQuery } from '@epilot/concorde-elements'
import classNames from 'classnames'

import classes from '../../Skeleton.module.scss'

export const MapSkeleton = () => {
  const isTabletOrMobile = useMediaQuery('(max-width: 750px)')

  return (
    <div className={classes.root}>
      {/* Mimics map */}
      <Skeleton
        className={classNames(
          isTabletOrMobile ? classes.mapMobile : classes.map
        )}
      >
        &nbsp;
      </Skeleton>
    </div>
  )
}
